import clsx from 'clsx';
import { MAX_ARTICLE_WIDTH } from '@_/theme/constants.ts';

export function ArticleWrapper({ children }: { children: React.ReactNode }) {
  return <div className={clsx(MAX_ARTICLE_WIDTH, 'mx-auto')}>{children}</div>;
}
